import { useEffect, useState } from 'react';

/**
 * Ba mốc responsive của bản web: thu gọn sidebar < 1060px, bố cục hẹp < 900px, điện thoại
 * < 640px (bỏ sidebar, dùng thanh tab dưới như app, chế độ học tập tràn màn hình).
 */
export function useViewport() {
  const [w, setW] = useState(() => (typeof window === 'undefined' ? 1280 : window.innerWidth));
  useEffect(() => {
    const f = () => setW(window.innerWidth);
    window.addEventListener('resize', f);
    return () => window.removeEventListener('resize', f);
  }, []);
  return { width: w, collapsed: w < 1060, narrow: w < 900, phone: w < 640 };
}
